import { useCallback, useMemo } from 'react';

import { DropdownChangeEvent } from 'primereact/dropdown';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { CalendarWrapper as Calendar } from '@/components/common/calendar-wrapper';
import { formatURLDate } from '@/utils';

type Props = {
  className?: string;
};

export const ChuteSchedulerCalendar = ({ className }: Props) => {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const date = useMemo(() => {
    return params.get('date')
      ? new Date(params.get('date') as string)
      : undefined;
  }, [params]);

  const handleDateChange = useCallback(
    (e: DropdownChangeEvent) => {
      const newParams = new URLSearchParams(params);
      if (e.value) {
        newParams.set('date', formatURLDate(e.value));
      } else {
        newParams.delete('date');
      }
      setParams(newParams);
    },
    [params, setParams],
  );

  return (
    <div
      className={`${className ? `${className} ` : ''} label-input-group flex flex-col`}
    >
      <label>{t('common.date')}</label>
      <Calendar
        value={date}
        placeholder="Select Date"
        dateFormat="mm-dd-yy"
        onChange={handleDateChange}
        showIcon
        className="h-10"
      />
    </div>
  );
};
